import {Component} from '@angular/core';

@Component({
  selector: 'pmd-footer-buttons',
  template: `<ng-content></ng-content>`,
  host: {
    class: 'pmd-navbar-right-icon ml-auto'
  }
})

export class PmdFooterButtons {}
